export default __webpack_public_path__ + "static/media/ErrorAlarme.c824da74.svg";